export var ActivityTypeE;
(function (ActivityTypeE) {
  ActivityTypeE["FOLLOW_UP"] = "follow-up";
  ActivityTypeE["CLIENT_APPLICATION_REQUEST"] = "client-application-request";
  ActivityTypeE["FILE"] = "file";
  ActivityTypeE["EMAIL"] = "email";
  ActivityTypeE["NOTE"] = "note";
  ActivityTypeE["DRIP_CAMPAIGN_CREATION"] = "drip-campaign-creation";
  ActivityTypeE["AUTOMATION"] = "automation";
  ActivityTypeE["ACCOUNT_CREATION"] = "account-creation";
  ActivityTypeE["CHECKLIST"] = "checklist";
  ActivityTypeE["EVENT"] = "event";
})(ActivityTypeE || (ActivityTypeE = {}));